import {
  saveEmailProvider,
  getEmailProvider,
  testEmailProviderConnection,
  deleteEmailProvider,
} from "../../api/email_provider";

const state = {
  provider: null,
  loading: false,
  testResult: null, // { success: bool, message: string }
  testLoading: false,
};

const getters = {
  provider: (state) => state.provider,
  isProviderConnected: (state) =>
    state.provider && state.provider.verified && state.provider.active,
  loading: (state) => state.loading,
  testResult: (state) => state.testResult,
  testLoading: (state) => state.testLoading,
};

const mutations = {
  SET_PROVIDER(state, provider) {
    state.provider = provider;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_TEST_RESULT(state, result) {
    state.testResult = result;
  },
  SET_TEST_LOADING(state, loading) {
    state.testLoading = loading;
  },
  CLEAR_PROVIDER(state) {
    state.provider = null;
    state.testResult = null;
  },
};

const actions = {
  async loadProvider({ commit }) {
    commit("SET_LOADING", true);
    try {
      const response = await getEmailProvider();
      if (response.status === 204) {
        commit("SET_PROVIDER", null);
      } else {
        commit("SET_PROVIDER", response.data);
      }
    } catch (error) {
      commit("SET_PROVIDER", null);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async saveProvider({ commit, dispatch }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await saveEmailProvider(data);
      commit("SET_PROVIDER", response.data);
      commit("SET_TEST_RESULT", null); // Clear previous test result
      return response.data;
    } catch (error) {
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async testConnection({ commit }) {
    commit("SET_TEST_LOADING", true);
    commit("SET_TEST_RESULT", null);
    try {
      const response = await testEmailProviderConnection();
      commit("SET_TEST_RESULT", response.data);
      if (response.data.success) {
        // Reload provider to get updated verified status
        const providerResponse = await getEmailProvider();
        if (providerResponse.status !== 204) {
          commit("SET_PROVIDER", providerResponse.data);
        }
      }
      return response.data;
    } catch (error) {
      const result = {
        success: false,
        message: error.response?.data?.message || "Connection test failed",
      };
      commit("SET_TEST_RESULT", result);
      return result;
    } finally {
      commit("SET_TEST_LOADING", false);
    }
  },

  async removeProvider({ commit }) {
    commit("SET_LOADING", true);
    try {
      await deleteEmailProvider();
      commit("CLEAR_PROVIDER");
    } catch (error) {
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
